<template>
  <el-row class="order-list">
    <el-row class="order-item" v-for="item in data.list" :class="item.union_status" :key="item.number">
      <el-col class="head" :span="24">
        <span class="number">{{item.number}}</span>
        <template v-if="item.union_status==='closed'">
          <span class="status">{{statusText(item)}}</span>
          <span v-if="item.order_type===3" class="status group-buying">拼团</span>&nbsp;
          <span v-if="item.order_type===2" class="status jizan">集赞</span>&nbsp;
          <el-tooltip class="item" effect="dark">
            <div slot="content">
              <span>取消时间：{{item.closed_at}}</span><br/>
              <span>取消类型：{{item.closed_by_text}}</span>
            </div>
            <i class="el-icon-info gray"></i>
          </el-tooltip>
        </template>
        <template v-else>
          <span class="status">{{statusText(item)}}</span>
          <span v-if="item.order_type===3" class="status group-buying">拼团</span>
          <span v-if="item.order_type===2" class="status jizan">集赞</span>
        </template>
        <span class="price"><i class="iconfont left gray">&#xe74b;</i>{{item.order_price/100}}元</span>
        <span class="price"><i class="left small gray">实付:</i>{{item.pay_price/100}}元</span>
        <i class="el-icon-edit main-color cursor-pointer" v-if="item.union_status==='paid_pending'" @click="editPayPrice(item)"></i>
        <span class="price"><i class="left small gray">积分:</i>{{item.score_discount/100}}元</span>
        <span class="price"><i class="left small gray">优惠券:</i>{{item.coupon_discount/100}}元</span>
        <span class="price"><i class="left small gray">VIP:</i>{{item.vip_discount/100}}元</span>
        <span class="price"><i class="left small gray">运费:</i>{{item.freight_fee/100}}元</span>
        <i class="el-icon-edit main-color cursor-pointer" v-if="item.union_status==='paid_pending'" @click="editFreight(item)"></i>
        <span class="price">
          <i class="left small gray">下单时间:</i>
          {{item.created_at}}&nbsp;
          <i class="left small gray">({{getDay(item.created_at)}})</i>
        </span>&nbsp;
        <el-tooltip class="item" effect="dark">
          <div slot="content">
            <p v-if="item.confirmed_at">确认时间：{{item.confirmed_at}}</p>
            <p v-if="item.paid_at">支付时间：{{item.paid_at}}</p>
            <p v-if="item.freighted_at">发货时间：{{item.freighted_at}}</p>
            <p v-if="item.finished_at">完成时间：{{item.finished_at}}</p>
            <p v-if="item.closed_at">取消时间：{{item.closed_at}}</p>
          </div>
          <i class="el-icon-info gray"></i>
        </el-tooltip>
      </el-col>
      <el-col class="skus" :span="24" v-if="item.single_sku">
        <div class="sku-item">
          <div class="sku-message">
            <p> 
              开通类型: 
              <span class="title main-color">{{item.single_sku.title}}</span>
            </p>
            <!-- <p>
              <span v-for="sku in value.attrs" :key="sku.k+sku.v"><i class="gray small">【{{sku.k}}】</i>{{sku.v}}&nbsp;&nbsp;</span>
            </p>
            <p class="price-total">
              <span><i class="gray small">数量: </i>{{value.total}}</span>
              <span><i class="gray small">售出价: </i>{{value.selling_price/100}}元</span>
              <span><i class="gray small">原价: </i><i class="line-through">{{value.original_price/100}}元</i></span>
            </p> -->
          </div>
        </div>
      </el-col>
      <el-col class="customer" :span="24">
        <div class="user-msg" v-if="item.user">
          <div class="headimg">
            <img :src="item.user.headimg">
          </div>
          <span class="name main-color">{{item.user.name}}</span>
        </div>
        <div class="user-remark" v-if="item.user_remark">
          <p>
            <el-tooltip class="item" effect="dark" content="用户备注">
              <i class="iconfont cursor-pointer">&#xe70c;</i>
            </el-tooltip>
            &nbsp;{{item.user_remark||'无'}}
          </p>
        </div>
        <div class="customer-remark">
          <p>
            <i class="gray small">商家备注:</i>&nbsp;
            {{item.seller_remark||'无'}}
            <i class="el-icon-edit main-color cursor-pointer" @click="sellerRemark(item)"></i>
          </p>
        </div>
        <div>
          <template v-if="item.options && item.options.address">
            <span class="address">
              <!-- <i class="iconfont error-color cursor-pointer">&#xe614;</i> -->
              {{item.options.address.name}}&nbsp;
              {{item.options.address.phone}}&nbsp;&nbsp;&nbsp;
              {{item.options.address.address}}&nbsp;
            </span>
          </template>
          <template v-else>无需实体卡</template>
        </div>
        <div class="single-freight" v-if="item.single_freight">
          <span @click="handleShowFreightDetail(item)">{{item.single_freight.freight_inc}}: {{item.single_freight.freight_number}}</span>
        </div>
      </el-col>
      <el-col class="aftersale" :span="24" v-if="item.aftersale">
        <div v-for="(step, idx) in item.aftersale.status_array" :key="idx">
          <div class="description"><span>{{ step.time }}</span> {{ step.event }}</div>
          <div class="img cursor-pointer" v-if="step.images && step.images.length">
            <img :src="img" v-for="(img, i) in step.images" :key="i" v-img-frame/>
          </div>
        </div>
      </el-col>
      <el-col class="freight" :span="24">
        <el-button
          v-if="item.union_status==='freight_pending'"
          size="mini"
          @click="freights(item)"
          type="primary">普通发货
        </el-button>
        <el-button
          v-if="item.union_status==='paid_pending'"
          size="mini"
          @click="closeOrder(item)"
          type="warning">关闭订单
        </el-button>
        <template v-if="item.union_status==='aftersale_pending'">
          <el-button
            v-if="item.aftersale.union_status==='receive_pending'"
            @click="aftersales('receive', item)"
            size="mini"
            type="primary">确认收货
          </el-button>
          <el-button
            v-if="item.aftersale.union_status==='refund_pending'"
            @click="inpurRefundMoney(item)"
            size="mini"
            type="primary">确认退款
          </el-button>
          <el-button
            v-if="item.aftersale.union_status==='audit_pending'"
            @click="aftersales('accept', item)"
            size="mini"
            type="primary">同意退款
          </el-button>
          <el-button
            v-if="item.aftersale.union_status==='audit_pending'"
            size="mini"
            @click="aftersales('reject', item)"
            type="danger">拒绝退款
          </el-button>
        </template>
      </el-col>
    </el-row>
    <el-dialog
      title="输入退款金额"
      :visible.sync="refundVisible"
      width="30%">
      <el-form label-width="80PX">
        <el-form-item label="退款金额">
          <el-input placeholder="请输入退款金额" v-model="required_money"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refundVisible = false">取 消</el-button>
        <el-button type="primary" @click="refund">确 定</el-button>
      </span>
    </el-dialog>
    <el-row style="margin-top:10px;margin-bottom:10px">
      <el-pagination
        v-if="data.list.length>0"
        background
        :current-page="data.page"
        layout="total, prev, pager, next"
        :page-size="data.per_page"
        :total="data.total"
        @current-change="currentChange">
      </el-pagination>
    </el-row>
    <el-row
      v-if="data.list.length===0">
      <img class="no-order" src="/static/images/no_order.png">
    </el-row>
    <template v-if="data.status === 'all' || data.status === 'freight_pending'">
      <el-dialog :visible.sync="freightLayer" title="订单发货" width="700px">
        <el-form label-width="100px" :rules="rules" :model="freightFrom">
          <el-form-item label="发货类型" prop="freight_type">
            <el-select v-model="freightFrom.freight_type" placeholder="请选择">
              <el-option label="物流发货" :value="1"></el-option>
              <el-option label="线上发货" :value="2"></el-option>
              <el-option label="其它方式" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-show="freightFrom.freight_type===1" prop="freight_inc" label="快递公司">
            <el-select v-model="freightFrom.freight_inc" placeholder="请选择">
              <el-option
                v-for="item in freightList"
                :key="item.inc"
                :label="item.inc"
                :value="item.inc">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-show="freightFrom.freight_type===1" prop="freight_number" label="快递单号">
            <el-input
              v-model="freightFrom.freight_number"
              placeholder="请输入"
              clearable>
            </el-input>
          </el-form-item>
          <el-form-item v-show="freightFrom.freight_type===1" label="发货备注">
            <el-input
              type="textarea"
              autosize
              v-model="freightFrom.freight_option"
              placeholder="请输入"
              clearable>
            </el-input>
          </el-form-item>
          <el-form-item v-show="freightFrom.freight_type===2" label="发货备注">
            <el-input v-model="freightFrom.online_option" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item v-show="freightFrom.freight_type===3" label="发货备注">
            <el-input v-model="freightFrom.other_option" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="sendGoods">确认发货</el-button>
            <el-button @click="freightLayer=false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </template>
    <el-dialog :visible.sync="freightLayer2" title="物流信息" width="700px" class="freight-dialog">
      <div class="freight-dialog-content">
        <p v-for="item in freightDetail.info" :key="item.time">
          <span>{{item.time}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span>{{item.context}}</span>
        </p>
      </div>
    </el-dialog>
  </el-row>
</template>
<script>
import MaskLayer from '@/components/MaskLayer'
import getDay from '@/utils/getDay'
import request from '@/utils/request'
export default {
  name: 'OrderItem',
  props: {
    data: {
      type: Object,
      default: _ => {
        return {
          page: 1,
          list: [],
          per_page: 10,
          total: 0,
          status: ''
        }
      }
    }
  },
  components: {
    MaskLayer
  },
  data () {
    return {
      freightLayer: false,
      freightLayer2: false,
      freightDetail: {},
      freightList: [],
      freightFrom: {
        type: 'freight',
        freight_type: 1, // 发货类型
        freight_inc: '', // 快递公司
        freight_code: '', // 快递公司代码
        freight_number: '', // 快递公司单号
        freight_option: '', // 发货备注
        online_option: '',
        other_option: ''
      },
      rules: {
        freight_type: [{ required: true, message: '请选择快递类型', trigger: 'change' }],
        freight_inc: [{ required: true, message: '请选择快递公司', trigger: 'change' }],
        freight_number: [{ required: true, message: '请输入快递单号', trigger: 'blur' }]
      },
      currentOrder: '',
      refundVisible: false,
      required_money: ''
    }
  },
  watch: {
    data: {
      handler () {
        if (this.data.status === 'all' || this.data.status === 'freight_pending') {
          request({
            url: 'freights',
            method: 'get'
          }).then(res => {
            this.freightList = res.data.freights
            this.freightFrom.freight_inc = this.freightList[0].inc || ''
          })
        }
      },
      deep: true
    }
  },
  methods: {
    handleShowFreightDetail (item) {
      request({
        url: `/orders/${item.uuid}/delivery`
      }).then(res => {
        this.freightLayer2 = true
        this.freightDetail = res.data
      })
    },
    currentChange (e) {
      this.$emit('currentChange', e)
    },
    statusText (item) {
      switch (item.union_status) {
        case 'aftersale_pending':
          return '售后中'
        case 'aftersale_finished':
          return '售后完成'
        case 'finished':
          return '已完成'
        case 'confirm_pending':
          return '待确认'
        case 'closed':
          return '已取消'
        case 'paid_pending':
          return '待付款'
        case 'paid_confirm_pending':
          return '付款确认中'
        case 'freight_pending':
          return '待发货'
        case 'freighted':
          return '已发货'
        case 'comment_pending':
          return '待评价'
        case 'group_buying_pending':
          return '待成团'
        case 'group_buying_failed':
          return '拼团失败'
      }
    },
    getDay (date) {
      return getDay(date)
    },
    editFreight (item) {
      let options = {
        title: '修改订单运费',
        data: item.freight_fee / 100, // 运费
        type: 'number'
      }
      let result = this.$editLayer.showLayer(options)
      result.then(value => {
        let sendData = {
          type: 'update_freight_fee',
          freight_fee: parseFloat(value) * 100
        }
        request({
          url: 'orders/' + item.uuid,
          method: 'patch',
          data: sendData
        }).then(res => {
          item.freight_fee = sendData.freight_fee
          this.$message.success('修改成功')
          this.$emit('action-success')
        })
      }).catch()
    },
    editPayPrice (item) {
      let options = {
        title: '修改订单价格',
        data: item.pay_price / 100, // 运费
        type: 'number'
      }
      let result = this.$editLayer.showLayer(options)
      result.then(value => {
        let sendData = {
          type: 'update_pay_money',
          pay_money: parseFloat(value) * 100
        }
        request({
          url: 'orders/' + item.uuid,
          method: 'patch',
          data: sendData
        }).then(res => {
          item.pay_price = sendData.pay_money
          this.$message.success('修改成功')
        })
      }).catch()
    },
    editAddress (item) {
      this.$address.showLayer(item.address).then(value => {
        let sendData = {
          type: 'update_address',
          address: value
        }
        request({
          url: 'orders/' + item.uuid,
          method: 'patch',
          data: sendData
        }).then(res => {
          this.$emit('action-success')
        })
      }).catch(_ => {})
    },
    sellerRemark (item) {
      let options = {
        title: '修改商家备注',
        data: item.seller_remark || '', // 商家备注
        type: 'string'
      }
      let result = this.$editLayer.showLayer(options)
      result.then(value => {
        let sendData = {
          type: 'remark',
          remark: value
        }
        request({
          url: 'orders/' + item.uuid,
          method: 'patch',
          data: sendData
        }).then(res => {
          this.$emit('action-success')
        })
      }).catch(_ => {})
    },
    freights (item) {
      this.freightLayer = true
      this.currentOrder = item
    },
    sendGoods () {
      let sendData = this.freightFrom
      if (sendData.freight_type === 1) {
        if (sendData.freight_number.trim() === '') {
          this.$message.error('快递单号不能为空!')
          return
        }
        this.freightList.forEach(item => {
          if (item.inc === sendData.freight_inc) {
            sendData.freight_code = item.code
          }
        })
      }
      request({
        url: 'orders/' + this.currentOrder.uuid,
        method: 'patch',
        data: sendData
      }).then(res => {
        this.freightLayer = false
        this.$message.success('发货成功!')
        this.freightFrom.freight_number = ''
        this.freightFrom.freight_option = ''
        this.$emit('action-success')
      })
    },
    closeOrder (item) {
      this.$confirm('此操作将永久关闭该订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: 'orders/' + item.uuid,
          method: 'patch',
          data: { type: 'close' }
        }).then(res => {
          this.$message.success('操作成功!')
          this.$emit('action-success')
        })
      }).catch(_ => {})
    },
    aftersales (type, item) {
      let tips = ''
      if (type === 'accept') {
        tips = '同意买家退款?'
        if (item.aftersale.type === 1) {
          tips = '同意退款将立即向客户原路退还款项，确定同意退款吗？'
        }
      } else if (type === 'reject') {
        tips = '拒绝买家退款?'
      } else if (type === 'receive') {
        tips = '确认收到买家退件?'
      }
      this.$confirm(tips, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: 'aftersales/' + item.aftersale.uuid,
          method: 'patch',
          data: { type: type }
        }).then(res => {
          this.$message.success('操作成功!')
          this.$emit('action-success')
        })
      }).catch(_ => {})
    },

    inpurRefundMoney (item) {
      this.refundVisible = true
      this.required_money = item.aftersale.required_money / 100
      this.currentOrder = item
    },

    refund () {
      let sendData = {
        type: 'refund',
        money: this.required_money * 100
      }
      request({
        url: 'aftersales/' + this.currentOrder.aftersale.uuid,
        method: 'patch',
        data: sendData
      }).then(res => {
        this.refundVisible = false
        this.$message.success('操作成功!')
        this.$emit('action-success')
      })
    }
  }
}
</script>
<style lang="less" scoped>
.freight-dialog {
  .freight-dialog-content {
    p {
      font-size: 14px;
      line-height: 28px;
      span:nth-child(1) {
        font-size: 13px;
      }
      span:nth-child(2) {
        color: #333333;
      }
    }
  }
}
.order-item {
  border: 1px solid #DCDFE6;
  border-top: 3px solid #00c0ef;
  margin-bottom: 13px;

  // aftersale售后中
  // finished已完成
  // confirm_pending待确认
  // closed已取消
  // paid_pending待付款
  // paid_confirm_pending付款确认中
  // freight_pending待发货
  // freighted已发货
  // .success {
  //   background-color: #67C23A;
  // }
  // .warning {
  //   background-color: #E6A23C;
  // }
  // .danger {
  //   background-color: #F56C6C;
  // }
  // .info {
  //   background-color: #909399;
  // }
  &.finished {
    border-top: 3px solid #67C23A;
    .status {
      background-color: #67C23A;
    }
  }
  &.closed, &.group_buying_failed, &.aftersale_pending, &.aftersale_finished {
    border-top: 3px solid #F56C6C;
    .status {
      background-color: #F56C6C;
    }
  }
  &.paid_pending, &.confirm_pending, &.paid_confirm_pending, &.group_buying_pending {
    border-top: 3px solid #E6A23C;
    .status {
      background-color: #E6A23C;
    }
  }
  &.freight_pending, &.aftersale {
    border-top: 3px solid #00c0ef;
    .status {
      background-color: #00c0ef;
    }
  }

  .status {
    color: #fff;
    background-color: #00c0ef;
    margin-left: 10px;
    border-radius: 3px;
    padding:  1px 3px;
    font-size: 11px;
  }

  .group-buying {
    background-color: #67C23A!important;
  }

  .jizan {
    background-color: #00c0ef!important;
  }

  i {
    font-style: normal;
  }

  .head {
    height: 33px;
    display: flex;
    align-items: center;
    padding: 0 15px;
    font-size: 14px;
    border-bottom: 1px solid #DCDFE6;

    .price {
      margin-left: 20px;
    }

    .left {
      margin-right: 3px;
    }

    .el-icon-edit {
      margin-left: 10px;
    }
  }

  .skus {
    padding-left: 50px;
    border-bottom: 1px solid #DCDFE6;

    .sku-item {
      border-bottom: 1px solid #DCDFE6;
      width: 100%;
      display: flex;
      padding: 6px 0;

      &:last-child {
        border-bottom: none;
      }

      .sku-message {
        margin-left: 15px;
        font-size: 14px;

        p {
          margin-top: 4px;

          &.price-total span {
            margin-right: 30px;
          }

          .number {
            margin-left: 20px;
          }
        }
      }
    }

    .img {
      width: 75px;
      height: 75px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .customer {
    padding: 0 15px;

    .user-msg {
      display: flex;
      align-items: center;
      padding: 5px 0;

      .headimg {
        width: 25px;
        height: 25px;
        border-radius: 3px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .name {
        margin-left: 5px;
        font-size: 14px;
      }

      .level {
        margin-left: 10px;
      }

      .address {
        margin-left: 20px;
        font-size: 14px;

        .iconfont {
          font-size: 17px;
          margin-right: 5px;
        }
      }
    }
    .user-remark, .customer-remark {
      font-size: 14px;
      margin-bottom: 5px;
    }
    .single-freight {
      font-size: 14px;
      color: #409EFF;
      span {
        cursor: pointer;
      }
    }
    .el-icon-edit {
      margin-left: 10px;
    }
  }
  .freight {
    padding: 0 15px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .aftersale {
    padding: 0 15px;
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 13px;
    span {
      color: #a0a0a0;
    }
    .img {
      height: 70px;
      padding: 10px 0;
      img {
        height: 70px;
        width: auto;
        display: inline-block;
        margin-right: 10px;
      }
    }
  }
}
.no-order {
  width: 600px;
  height: auto;
  display: block;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/vip/components/orderItem.vue